/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/SubmitAction/Content",
  disabled
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  disabled
  
})
let connectionAutomationIdValueData = fromData.useDataValue({ viewPath,
context: 'connection',
path: 'automation_id',
})
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="primary"
 data="steps"
 onClick={onClick}
 disabled={disabled}
 alignSelf="flex-end"
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text={connectionAutomationIdValueData ? "Save" : "Finish"}
 data="connection.automation_id"
/>
)}
</TysiaButton>
{children}
</React.Fragment>)
}